import { PageHeader } from "../../common/form-elements";

const Shimmer = "animate-pulse bg-gray-200 rounded-md";

const Sk = ({ className }) => <div className={`${Shimmer} ${className}`} />;

const AddResidentialPropertyPageSkeleton = () => {
  return (
    <div className="min-h-screen bg-background font-poppins">
      <PageHeader title="Loading Property..." />

      <div className="max-full mx-auto px-3 sm:px-4 md:px-6 py-4">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          {/* LEFT COLUMN */}
          <div className="space-y-6">
            {/* Project Name */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <Sk className="h-5 w-40 mb-3" />
              <Sk className="h-10 w-full" />
            </div>

            {/* Images Upload */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <Sk className="h-5 w-64 mb-2" />
              <Sk className="h-4 w-48 mb-4" />
              <Sk className="h-56 w-full rounded-lg" />
            </div>

            {/* Brochure */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <Sk className="h-5 w-40 mb-2" />
              <Sk className="h-4 w-56 mb-4" />
              <Sk className="h-20 w-full rounded-lg" />
            </div>

            {/* Video Section */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <Sk className="h-5 w-52 mb-2" />
              <Sk className="h-4 w-64 mb-4" />
              <Sk className="h-48 w-full rounded-lg" />
            </div>
          </div>

          {/* MIDDLE COLUMN */}
          <div className="space-y-6">
            {/* Property Description */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <Sk className="h-5 w-48 mb-4" />
              <Sk className="h-32 w-full rounded-lg" />
            </div>

            {/* Why Consider */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <Sk className="h-5 w-64 mb-4" />
              <Sk className="h-32 w-full rounded-lg" />
            </div>

            {/* Floor Details */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <Sk className="h-5 w-40 mb-3" />
              <div className="grid grid-cols-2 gap-3 mt-2">
                <Sk className="h-10 w-full" />
                <Sk className="h-10 w-full" />
              </div>
            </div>

            {/* Floor Plan */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <Sk className="h-5 w-40 mb-3" />
              <Sk className="h-48 w-full rounded-lg" />
            </div>
          </div>

          {/* RIGHT COLUMN */}
          <div className="space-y-6">
            {/* Builder Name */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <Sk className="h-5 w-48 mb-3" />
              <Sk className="h-10 w-full" />
            </div>

            {/* Brokerage */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <Sk className="h-5 w-40 mb-3" />
              <Sk className="h-10 w-full" />
            </div>

            {/* Availability */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <Sk className="h-5 w-48 mb-3" />
              <Sk className="h-10 w-full" />
            </div>

            {/* Ownership */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <Sk className="h-5 w-44 mb-3" />
              <Sk className="h-10 w-full" />
            </div>

            {/* Amenities */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <Sk className="h-5 w-40 mb-3" />
              <Sk className="h-10 w-full mb-2" />
              <Sk className="h-10 w-full" />
            </div>

            {/* Location */}
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
              <Sk className="h-5 w-40 mb-3" />
              <Sk className="h-10 w-full" />
            </div>

            {/* Submit */}
            <Sk className="h-12 w-full rounded-full" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddResidentialPropertyPageSkeleton;
